// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// init Swiper:
const swiperPdp = document.querySelector('#swiper-collection-slider');
if (swiperPdp) {
  const sliderData = JSON.parse(swiperPdp.getAttribute('data-slider-settings'));
  const swiper = new Swiper('#swiper-collection-slider', sliderData);
}
